const VALIDATION_MESSAGES = {
  "pretestPrimaryWaterHeaterAppliance": "Please select just ONE option for primary water heater appliance.",
  "pretestPrimaryWaterHeaterCombType": "Please select just ONE option for primary water heater comb. type.",
  "pretestSecondaryWaterHeaterAppliance": "Please select just ONE option for secondary water heater appliance.",
  "pretestSecondaryWaterHeaterCombType": "Please select just ONE option for secondary water heater comb. type.",
  "pretestPrimarySelectYesOrNo_1": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_2": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_3": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_4": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_5": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_6": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_7": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_8": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_9": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_10": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_1": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_2": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_3": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_4": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_5": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_6": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_7": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_8": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_9": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_10": "Please select only yes or no.",
  "primaryCorrectionsOneChoice_2": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_3": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_4": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_5": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_7": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_8": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_9": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "primaryCorrectionsOneChoice_10": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_2": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_3": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_4": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_5": "Please select only one checkbox: 'yes', 'no', 'na'.",
  "secondaryCorrectionsOneChoice_7": "Please select only one checkbox: 'yes', 'no', 'na'.1",
  "secondaryCorrectionsOneChoice_8": "Please select only one checkbox: 'yes', 'no', 'na'.2",
  "secondaryCorrectionsOneChoice_9": "Please select only one checkbox: 'yes', 'no', 'na'.3",
  "secondaryCorrectionsOneChoice_10": "Please select only one checkbox: 'yes', 'no', 'na'.4",
  "preTestPrimaryOpenDoorPPMOnlyOne": "Please select only one checkbox PPM.",
  "preTestSecondaryOpenDoorPPMOnlyOne": "Please select only one checkbox PPM.",
  "preTestPrimaryClosedDoorPPMOnlyOne": "Please select only one checkbox PPM.",
  "preTestSecondaryClosedDoorPPMOnlyOne": "Please select only one checkbox PPM.",
  "postTestPrimaryOpenDoorPPMOnlyOne": "Please select only one checkbox PPM.1",
  "postTestSecondaryOpenDoorPPMOnlyOne": "Please select only one checkbox PPM.2",
  "postTestPrimaryClosedDoorPPMOnlyOne": "Please select only one checkbox PPM.3",
  "postTestSecondaryClosedDoorPPMOnlyOne": "Please select only one checkbox PPM.4",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "preTestPrimary_storage": () => ({
      validate: () => {
        const primaryWaterHeaterAppliance = ["preTestPrimary_storage", "preTestPrimary_tanklessIndoor", "preTestPrimary_tanklessOutdoor"];
        const count = primaryWaterHeaterAppliance.filter(appliance => !!getValues(appliance)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimaryWaterHeaterAppliance'];
      },
    }),
    "preTestPrimary_naturalDraft": () => ({
      validate: () => {
        const primaryWaterHeaterCombType = ["preTestPrimary_naturalDraft", "preTestPrimary_inducedDraft", "preTestPrimary_closed"];
        const count = primaryWaterHeaterCombType.filter(appliance => !!getValues(appliance)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimaryWaterHeaterCombType'];
      },
    }),
    "preTestSecondary_storage": () => ({
      validate: () => {
        const secondaryWaterHeaterAppliance = ["preTestSecondary_storage", "preTestSecondary_tanklessIndoor", "preTestSecondary_tanklessOutdoor"];
        const count = secondaryWaterHeaterAppliance.filter(appliance => !!getValues(appliance)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondaryWaterHeaterAppliance'];
      },
    }),
    "preTestSecondary_naturalDraft": () => ({
      validate: () => {
        const secondaryWaterHeaterCombType = ["preTestSecondary_naturalDraft", "preTestSecondary_inducedDraft", "preTestSecondary_closed"];
        const count = secondaryWaterHeaterCombType.filter(appliance => !!getValues(appliance)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondaryWaterHeaterCombType'];
      },
    }),
    "primaryConditions_1_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_1_yes", "primaryConditions_1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_1'];
      },
    }),
    "primaryConditions_2_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_2_yes", "primaryConditions_2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_2'];
      },
    }),
    "primaryConditions_3_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_3_yes", "primaryConditions_3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_3'];
      },
    }),
    "primaryConditions_4_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_4_yes", "primaryConditions_4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_4'];
      },
    }),
    "primaryConditions_5_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_5_yes", "primaryConditions_5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_5'];
      },
    }),
    "primaryConditions_6_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_6_yes", "primaryConditions_6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_6'];
      },
    }),
    "primaryConditions_7_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_7_yes", "primaryConditions_7_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_7'];
      },
    }),
    "primaryConditions_8_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_8_yes", "primaryConditions_8_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_8'];
      },
    }),
    "primaryConditions_9_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_9_yes", "primaryConditions_9_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_9'];
      },
    }),
    "primaryConditions_10_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryConditions_10_yes", "primaryConditions_10_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_10'];
      },
    }),
    "secondaryConditions_1_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_1_yes", "secondaryConditions_1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_1'];
      },
    }),
    "secondaryConditions_2_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_2_yes", "secondaryConditions_2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_2'];
      },
    }),
    "secondaryConditions_3_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_3_yes", "secondaryConditions_3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_3'];
      },
    }),
    "secondaryConditions_4_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_4_yes", "secondaryConditions_4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_4'];
      },
    }),
    "secondaryConditions_5_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_5_yes", "secondaryConditions_5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_5'];
      },
    }),
    "secondaryConditions_6_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_6_yes", "secondaryConditions_6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_6'];
      },
    }),
    "secondaryConditions_7_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_7_yes", "secondaryConditions_7_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_7'];
      },
    }),
    "secondaryConditions_8_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_8_yes", "secondaryConditions_8_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_8'];
      },
    }),
    "secondaryConditions_9_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_9_yes", "secondaryConditions_9_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_9'];
      },
    }),
    "secondaryConditions_10_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryConditions_10_yes", "secondaryConditions_10_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_10'];
      },
    }),
    "primaryCorrections_2_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_2_yes", "primaryCorrections_2_no", "primaryCorrections_2_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_2'];
      },
    }),
    "primaryCorrections_3_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_3_yes", "primaryCorrections_3_no", "primaryCorrections_3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_3'];
      },
    }),
    "primaryCorrections_4_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_4_yes", "primaryCorrections_4_no", "primaryCorrections_4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_4'];
      },
    }),
    "primaryCorrections_5_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_5_yes", "primaryCorrections_5_no", "primaryCorrections_5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_5'];
      },
    }),
    "primaryCorrections_7_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_7_yes", "primaryCorrections_7_no", "primaryCorrections_7_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_7'];
      },
    }),
    "primaryCorrections_8_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_8_yes", "primaryCorrections_8_no", "primaryCorrections_8_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_8'];
      },
    }),
    "primaryCorrections_9_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_9_yes", "primaryCorrections_9_no", "primaryCorrections_9_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_9'];
      },
    }),
    "primaryCorrections_10_yes": () => ({
      validate: () => {
        const yesOrNo = ["primaryCorrections_10_yes", "primaryCorrections_10_no", "primaryCorrections_10_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryCorrectionsOneChoice_10'];
      },
    }),
    "secondaryCorrections_2_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_2_yes", "secondaryCorrections_2_no", "secondaryCorrections_2_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_2'];
      },
    }),
    "secondaryCorrections_3_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_3_yes", "secondaryCorrections_3_no", "secondaryCorrections_3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_3'];
      },
    }),
    "secondaryCorrections_4_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_4_yes", "secondaryCorrections_4_no", "secondaryCorrections_4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_4'];
      },
    }),
    "secondaryCorrections_5_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_5_yes", "secondaryCorrections_5_no", "secondaryCorrections_5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_5'];
      },
    }),
    "secondaryCorrections_7_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_7_yes", "secondaryCorrections_7_no", "secondaryCorrections_7_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_7'];
      },
    }),
    "secondaryCorrections_8_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_8_yes", "secondaryCorrections_8_no", "secondaryCorrections_8_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_8'];
      },
    }),
    "secondaryCorrections_9_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_9_yes", "secondaryCorrections_9_no", "secondaryCorrections_9_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_9'];
      },
    }),
    "secondaryCorrections_10_yes": () => ({
      validate: () => {
        const yesOrNo = ["secondaryCorrections_10_yes", "secondaryCorrections_10_no", "secondaryCorrections_10_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryCorrectionsOneChoice_10'];
      },
    }),
    "preTestPrimaryOpenDoor_nf": () => ({
      validate: () => {
        const options = ["preTestPrimaryOpenDoor_nf", "preTestPrimaryOpenDoor_hazard", "preTestPrimaryOpenDoor_fail", "preTestPrimaryOpenDoor_baffle", "preTestPrimaryOpenDoor_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestPrimaryOpenDoorPPMOnlyOne'];
      },
    }),
    "preTestSecondaryOpenDoor_nf": () => ({
      validate: () => {
        const options = ["preTestSecondaryOpenDoor_nf", "preTestSecondaryOpenDoor_hazard", "preTestSecondaryOpenDoor_fail", "preTestSecondaryOpenDoor_baffle", "preTestSecondaryOpenDoor_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSecondaryOpenDoorPPMOnlyOne'];
      },
    }),
    "preTestPrimaryClosedDoor_nf": () => ({
      validate: () => {
        const options = ["preTestPrimaryClosedDoor_nf", "preTestPrimaryClosedDoor_hazard", "preTestPrimaryClosedDoor_fail", "preTestPrimaryClosedDoor_baffle", "preTestPrimaryClosedDoor_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestPrimaryClosedDoorPPMOnlyOne'];
      },
    }),
    "preTestSecondaryClosedDoor_nf": () => ({
      validate: () => {
        const options = ["preTestSecondaryClosedDoor_nf", "preTestSecondaryClosedDoor_hazard", "preTestSecondaryClosedDoor_fail", "preTestSecondaryClosedDoor_baffle", "preTestSecondaryClosedDoor_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSecondaryClosedDoorPPMOnlyOne'];
      },
    }),
    "postTestPrimaryOpenDoor_nf": () => ({
      validate: () => {
        const options = ["postTestPrimaryOpenDoor_nf", "postTestPrimaryOpenDoor_hazard", "postTestPrimaryOpenDoor_fail", "postTestPrimaryOpenDoor_baffle", "postTestPrimaryOpenDoor_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimaryOpenDoorPPMOnlyOne'];
      },
    }),
    "postTestSecondaryOpenDoor_nf": () => ({
      validate: () => {
        const options = ["postTestSecondaryOpenDoor_nf", "postTestSecondaryOpenDoor_hazard", "postTestSecondaryOpenDoor_fail", "postTestSecondaryOpenDoor_baffle", "postTestSecondaryOpenDoor_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSecondaryOpenDoorPPMOnlyOne'];
      },
    }),
    "postTestPrimaryClosedDoor_nf": () => ({
      validate: () => {
        const options = ["postTestPrimaryClosedDoor_nf", "postTestPrimaryClosedDoor_hazard", "postTestPrimaryClosedDoor_fail", "postTestPrimaryClosedDoor_baffle", "postTestPrimaryClosedDoor_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimaryClosedDoorPPMOnlyOne'];
      },
    }),
    "postTestSecondaryClosedDoor_nf": () => ({
      validate: () => {
        const options = ["postTestSecondaryClosedDoor_nf", "postTestSecondaryClosedDoor_hazard", "postTestSecondaryClosedDoor_fail", "postTestSecondaryClosedDoor_baffle", "postTestSecondaryClosedDoor_ventTermin"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSecondaryClosedDoorPPMOnlyOne'];
      },
    }),
  };
};

export default useValidation;
